export default "__VITE_PUBLIC_ASSET__f2cc735b__"